var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-container"},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"page-title"},[_vm._v("설정")])])])
}]

export { render, staticRenderFns }